import cn from 'classnames';
import { Link } from 'react-router';

const DefaultLink = ({
  isExternal = false,
  onClick = () => {},
  variation = 'Secondary',
  children,
  className,
  to,
  ...restProps
}) => {
  if (isExternal) {
    return (
      <a
        href={to}
        className={cn(className, 'text', `link${variation}`)}
        onClick={onClick}
        {...restProps}
      >
        {children}
      </a>
    );
  } else {
    return (
      <Link
        to={to}
        className={cn(className, 'text', `link${variation}`)}
        onClick={onClick}
        {...restProps}
      >
        {children}
      </Link>
    );
  }
};

DefaultLink.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isExternal: PropTypes.bool,
  variation: PropTypes.oneOf(['Primary', 'Secondary', 'TextPrimary', 'TextSecondary']),
  target: PropTypes.string,
  rel: PropTypes.string,
};

export default DefaultLink;
